
import { ISpPageContext } from '@ms/odsp-datasources/lib/interfaces/ISpPageContext';
import { spItemKeyFacet, spPageContextKeyFacet } from '../../dataSource/Keys';
import { spPageContextFacet } from '../../dataSource/Facets';
import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';

/**
* Get the PageContextInfo JSON from our item cache
* @param itemCache
* @param itemKey
*/
export function getPageContextFromItemCache(itemCache: IItemCache, itemKey: string | undefined): ISpPageContext | undefined {
  // Get the Key, so that we can get the page context info
  const { key } = itemCache.demandItem({ key: spItemKeyFacet, }, itemKey);

  // Get the pageContextInfo
  const pageContext: ISpPageContext | undefined = key && itemCache.demandItemFacet(spPageContextFacet,
    spPageContextKeyFacet.serialize({ webAbsoluteUrl: key.webAbsoluteUrl, listFullUrl: key.listFullUrl }));

  return pageContext;
}
